import { useCategories } from '../context/CategoryContext';
import { Card } from './ui/card';
import { Button } from './ui/button';

interface CategoryStepProps {
  handleNext: () => void;
  handlePrev: () => void;
  selectedCategory: string;
  handleCategoryChange: (category: string) => void;
}

const CategoryStep = ({
  handleNext,
  handlePrev,
  selectedCategory,
  handleCategoryChange,
}: CategoryStepProps) => {
  const { categories } = useCategories();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">어떤 주제의 설문인가요?</h2>

      <div className="grid grid-cols-3 gap-3">
        {categories.map((category) => (
          <Card
            key={category.id}
            className={`
              py-3 px-3 cursor-pointer transition-all
              border-2
              ${
                String(selectedCategory) === String(category.id)
                  ? 'border-primary bg-primary/10 ring-2 ring-primary/30 shadow-md'
                  : 'border-transparent hover:border-gray-300'
              }
            `}
            onClick={() => handleCategoryChange(category.id)}
          >
            <div className="text-center">
              <div className="text-xl mb-1">{category.categoryEmoji}</div>
              <div className="text-sm font-medium">{category.categoryNameKr}</div>
            </div>
          </Card>
        ))}
      </div>

      {/* 버튼 */}
      <div className="sticky bottom-0 pt-4 flex gap-3">
        <Button variant="outline" className="flex-1" size="lg" onClick={handlePrev}>
          뒤로
        </Button>
        <Button className="flex-1" size="lg" disabled={!selectedCategory} onClick={handleNext}>
          다음
        </Button>
      </div>
    </div>
  );
};

export default CategoryStep;
